import heavyIndustryCover from '../assets/heavy_industry_cover.jpg';

const videoUrl =
  'https://assets.salieflewis.com/heavy_industry_3_channel_v1.mov';

export function HeavyIndustry() {
  return (
    <div className="flex h-full min-h-0 w-full items-center justify-center overflow-hidden p-4">
      <div className="flex h-full min-h-0 w-full max-w-[760px] items-center justify-center">
        {/* biome-ignore lint/a11y/useMediaCaption: The source video does not currently have captions. */}
        <video
          className="block h-auto max-h-full w-full bg-black object-contain"
          src={videoUrl}
          poster={heavyIndustryCover}
          controls
          playsInline
          preload="metadata"
        />
      </div>
    </div>
  );
}
